"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _text = require("@mmc/text");

var _commonRichText = require("@mmc/common-rich-text");

var _commonShareSocial = _interopRequireDefault(require("./common-share-social"));

var _commonShareUrl = _interopRequireDefault(require("./common-share-url"));

var _commonShareDialog = require("./common-share-dialog.prop-types");

var _commonShareDialog2 = _interopRequireDefault(require("./common-share-dialog.css"));

var CommonShareDialog = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(CommonShareDialog, _React$PureComponent);

  function CommonShareDialog() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = CommonShareDialog.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        theme = _this$props.theme,
        className = _this$props.className,
        onClose = _this$props.onClose,
        headline = _this$props.headline,
        imagePath = _this$props.imagePath,
        imageAltText = _this$props.imageAltText,
        title = _this$props.title,
        subtitle = _this$props.subtitle,
        description = _this$props.description,
        email = _this$props.email,
        twitter = _this$props.twitter,
        facebook = _this$props.facebook,
        url = _this$props.url,
        text = _this$props.text,
        disclaimerData = _this$props.disclaimerData;
    var hasSocial = !(0, _isEmpty2["default"])(twitter) || !(0, _isEmpty2["default"])(facebook) || !(0, _isEmpty2["default"])(email);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonShareDialog2["default"].overlay
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(_commonShareDialog2["default"].shareDialog, className)
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _clsx["default"])(_commonShareDialog2["default"].closeBtn, theme.black),
      type: "button",
      onClick: onClose
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: (0, _clsx["default"])(theme.mmcIconCrossThin, _commonShareDialog2["default"].closeIcon)
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonShareDialog2["default"].headlineContainer
    }, headline && /*#__PURE__*/_react["default"].createElement("p", {
      className: _commonShareDialog2["default"].headline
    }, headline), imagePath && /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonShareDialog2["default"].hero
    }, /*#__PURE__*/_react["default"].createElement("img", {
      alt: imageAltText,
      src: imagePath
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonShareDialog2["default"].bodyContainer
    }, title && /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      className: _commonShareDialog2["default"].title,
      theme: theme,
      html: title,
      format: "inherit"
    }), subtitle && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        className: _commonShareDialog2["default"].subtitle,
        theme: theme,
        html: subtitle,
        format: "inherit"
      }),
      disclaimerData: disclaimerData,
      tooltipPlacement: "right"
    }), description && /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      className: _commonShareDialog2["default"].description,
      theme: theme,
      html: description,
      format: "inherit"
    }), url && /*#__PURE__*/_react["default"].createElement(_commonShareUrl["default"], {
      theme: theme,
      url: url
    }), hasSocial && /*#__PURE__*/_react["default"].createElement(_commonShareSocial["default"], {
      email: email,
      facebook: facebook,
      twitter: twitter,
      theme: theme,
      text: text,
      url: url
    }))));
  };

  return CommonShareDialog;
}(_react["default"].PureComponent);

exports["default"] = CommonShareDialog;
CommonShareDialog.displayName = 'CommonShareDialog';
CommonShareDialog.defaultProps = {
  onClose: function onClose() {
    return undefined;
  }
};